import _ from 'lodash';

import shuffleSeed from 'shuffle-seed';

import PropTypes from 'prop-types';

import { cmsService } from '../services/homii-services';

import useResponsive from '../../utils/responsive';

import HeroSection from '../components/live-page-components/hero-section.component';

import VideoSection from '../components/live-page-components/video-section.component';

import MobileAppSection from '../components/live-page-components/our-app/mobile-app-section.component';

import MobileAppSectionDark from '../components/home-page-components/mobile-app-section.component';

import IconSection from '../components/lead-gen-components/icon-section.component';

import { Layout, Footer, MetaData } from '../components/shared';

import LeadGenSalesForm from '../components/get-in-touch-components/lead-gen-sales-form.component';

import GalleryCarousel from '../components/gallery/gallery-carousel.component';
import GalleryCarouselMobile from '../components/gallery/gallery-carousel-mobile.component';

const SEED = 'HOMiiVal';

const Sales = (props) => {
    const { isMobile, isTablet } = useResponsive();
    const { data, baseUrlApp, gallery } = props;
    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const heroTitle = _.get(data, 'acf.hero_title');
    const heroImgSrc = _.get(data, 'acf.hero_main_image');
    const heroImgAlt = _.get(data, 'acf.hero_main_image_alt');
    const videoUrl = _.get(data, 'acf.video_url');
    const iconSectionTitle = _.get(data, 'acf.icon_section_title');
    const iconSectionParagraph = _.get(data, 'acf.icon_section_paragraph');
    const iconSectionIcons = _.get(data, 'acf.icon_section_icons');
    const appTitle = _.get(data, 'acf.app_section_title');
    const appParagraph = _.get(data, 'acf.app_section_paragraph');
    const appImage = _.get(data, 'acf.app_section_image.url');
    const appImageAlt = _.get(data, 'acf.image_alt');
    const mobileAppTitle = _.get(data, 'acf.mobile_title');
    const mobileAppParagraph = _.get(data, 'acf.mobile_paragraph');
    const mobileAppIcon = _.get(data, 'acf.mobile_icon.url');
    const mobileAppIconText = _.get(data, 'acf.mobile_icon_text');
    const mobilePrimaryImgSrc = _.get(data, 'acf.mobile_primary_image.url');
    const mobilePrimaryImgAlt = _.get(data, 'acf.mobile_primary_image_alt');
    const mobileAppSecondaryImgSrc = _.get(data, 'acf.mobile_secondary_image.url');
    const mobileAppSecondaryImgAlt = _.get(data, 'acf.mobile_secondary_image_alt');
    const formBuildingData = _.get(data, 'acf.buildings');
    const formRoomTypeCategoriesData = _.get(data, 'acf.room_type_categories');
    const formSalesAgentsData = _.get(data, 'acf.sales_agents');
    const media = _.get(gallery, 'acf.items');

    const renderLeadGenForms = () => {
        return (
            <div>
                <div className='sales-component-container'>
                    <div className='sales-form-container'>
                        <LeadGenSalesForm
                            formBuildingData={formBuildingData}
                            formRoomTypeCategoriesData={formRoomTypeCategoriesData}
                            formSalesAgentsData={formSalesAgentsData}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Layout>

            <MetaData title={seoTitle} desc={seoMetaDesc} canonical={`${baseUrlApp}/sales`} />

            <div className='sales-hero-section-container'>                
                <HeroSection
                    isLeadGenSales
                    title={heroTitle}
                    imgSrc={heroImgSrc}
                    imgAlt={heroImgAlt}
                    isMobile={isMobile}
                    isTablet={isTablet}
                    id="sales_header"
                    formBuildingData={formBuildingData}
                    formRoomTypeCategoriesData={formRoomTypeCategoriesData}
                    formSalesAgentsData={formSalesAgentsData}
                />
            </div>
            
            <div className='sales-icon-container'>
                {renderLeadGenForms()}
                <div className='sales-icon-section-container'>
                    <IconSection
                        title={iconSectionTitle}
                        paragraph={iconSectionParagraph}
                        icons={iconSectionIcons}
                    />
                </div>
            </div>            

            <div className='container-root container-root-maxWidthLg'>
                <MobileAppSection
                    title={appTitle}
                    paragraph={appParagraph}
                    imgSrc={appImage}
                    imgAlt={appImageAlt}
                />
            </div>

            <VideoSection
                videoUrl={videoUrl}                
                alignRight
                marginTop={100}
                marginBottom={150}
                marginTopMobile={60}
                marginBottomMobile={60}
            />

            {isMobile ? 
                <div className='carousel-container-mobile'>
                    <GalleryCarouselMobile category="All Topics" data={shuffleSeed.shuffle(media, SEED)} inDialog={false} selectedIndex={1} />
                </div>
                :
                <div className='container-root container-root-maxWidthLg blog-carousel-container building-carousel-container-settings'>
                    <div style={{ marginBottom: 183 }}> 
                        <GalleryCarousel category="All Topics" data={shuffleSeed.shuffle(media, SEED)} inDialog={false} selectedIndex={1} />
                    </div>
                </div>
            }

            <div className='sales-mobile-app-section-container'>
                <MobileAppSectionDark
                    isDark
                    isMobile={isMobile}
                    title={mobileAppTitle}
                    paragraph={mobileAppParagraph}
                    icon={mobileAppIcon}
                    iconText={mobileAppIconText}
                    primaryImgSrc={mobilePrimaryImgSrc}
                    primaryImgAlt={mobilePrimaryImgAlt}
                    secondaryImgSrc={mobileAppSecondaryImgSrc}
                    secondaryImgAlt={mobileAppSecondaryImgAlt}
                />
            </div>

            <Footer />

        </Layout>
    );
};

export default Sales;

export const getServerSideProps = async ({ }) => {
    const data = await cmsService.RetrieveWordPressPage('sales');    
    const respGallery = await cmsService.RetrieveWordPressPage('gallery');
    return { props: { data, gallery: respGallery } };
};

Sales.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
    gallery: PropTypes.object,
};

